<template>
  <v-data-table v-if="recursosContrarrazoes && recursosContrarrazoes.length > 0"
                :headers="colunasTabela"
                :items="recursosContrarrazoes"
                hide-actions
                class="az-table-list table-dados-edital">
    <template slot="items" slot-scope="props">
      <tr>
        <td class="px-2">
          <span>{{ props.item.fornecedor.razaoSocial }}</span>
        </td>
        <td class="px-2">
          <span>{{ extrairLotes(props.item.lotes) }}</span>
        </td>
        <td class="px-2">
          <span>{{ props.item.dataEnvio | az-date('DD/MM/YYYY HH:mm') }}</span>
        </td>
        <td class="px-2" style="text-align: center">
          <span v-if="props.item.respondido">
            Respondido
          </span>
          <span v-else>
            Aguardando Resposta
            <v-tooltip v-if="!ehFornecedor" top>
              <v-icon slot="activator" class="px-1" size="15" color="orange">info</v-icon>
              <span v-if="tipo===tipoRecursoContrarrazao.RECURSO">
                Este <strong>Recurso</strong>
              </span>
              <span v-else>
                Esta <strong>Contrarrazão</strong>
              </span>
              está aguardando resposta
            </v-tooltip>
          </span>
        </td>
        <td class="table-actions justify-space-between" style="display: flex; flex-flow: row-reverse">
          <div>
            <span>
            <v-tooltip top v-if="ehFornecedor">
              <a v-if="exibirCriarContrarrazao(props.item)" slot="activator"
                 :class="prazoEncerrado(props.item)?'no-hover':''" @click.prevent="criarContrarrazao(props.item.id)">
                <v-icon class="px-1" v-show="!prazoEncerrado(props.item)">reply</v-icon>
                <v-icon class="px-1" v-show="prazoEncerrado(props.item)" style="color: #b0b0b0">reply</v-icon>
              </a>
              <span v-if="!prazoEncerrado(props.item)">Criar Contrarrazão</span>
              <span v-if="prazoEncerrado(props.item)">O prazo para envio de contrarrazões foi encerrado <br> conforme <strong>LEI Nº 14.133, DE 1º DE ABRIL DE 2021</strong></span>
            </v-tooltip>
            </span>
            <span>
            <v-tooltip top v-if="!ehFornecedor">
              <span slot="activator">
                <a @click.prevent="responderRecursoContrarrazao(props.item.id)" title="Responder">
                  <v-icon class="px-1">reply</v-icon>
                </a>
              </span>
              <span>Responder</span>
            </v-tooltip>
            </span>
            <v-tooltip top>
              <a slot="activator" @click.prevent="visualizarRecursoContrarrazao(props.item.id)" title="Visualizar">
                <v-icon class="px-1 pr-3">search</v-icon>
              </a>
              <span>Visualizar</span>
            </v-tooltip>
          </div>
        </td>
      </tr>
    </template>
  </v-data-table>
  <div v-else class="tabela-vazia">
    <span v-if="ehRecurso">
      Nenhum recurso criado
    </span>
    <span v-if="ehContrarrazao">
      Nenhuma contrarrazão criada
    </span>
  </div>
</template>
<script>
import ModalInserirRecurso from "@/views/licitacao/detalhe/orgao/recursocontrarrazao/modal/ModalInserirRecurso.vue";
import {tipoRecursoContrarrazao} from "@/commons/constants";
import {mapState} from "vuex";

export default {
  name: 'LicitacaoRecursoContrarrazaoTabela',
  components: {ModalInserirRecurso},
  props:{
    ehFornecedor:{
      type: Boolean,
      default: true
    },
    recursosContrarrazoes:{
      type: Array,
      default: () => []
    },
    contrarrazoes:{
      type: Array,
      default: () => []
    },
    tipo:{
      type: String,
      default: tipoRecursoContrarrazao.RECURSO
    },
  },
  data() {
    return {
      tipoRecursoContrarrazao,
      colunasTabela: [
        {
          text: 'Licitante',
          align: 'left',
          sortable: false,
          width: '200px',
          class: 'primary--text'
        },
        {
          text: 'Tipos',
          align: 'left',
          sortable: false,
          width: '200px',
          class: 'primary--text'
        },
        {
          text: 'Envio',
          align: 'left',
          sortable: false,
          width: '125px',
          class: 'primary--text'
        },
        {
          text: 'Situação',
          sortable: false,
          width: '180px',
          align: 'center',
          class: 'primary--text'
        },
        {
          text: 'Ações',
          sortable: false,
          align: 'center',
          width: '150px',
          class: 'primary--text'
        }
      ],
    }
  },
  computed:{
    ...mapState(['propostaResumo']),
    ehContrarrazao(){
      return this.tipo===tipoRecursoContrarrazao.CONTRARRAZAO
    },
    ehRecurso(){
      return this.tipo===tipoRecursoContrarrazao.RECURSO
    },
    ehFornecedorParticipante(){
      return !!this.propostaResumo.enviada
    }
  },
  methods:{
    visualizarRecursoContrarrazao(idRecurso){
      this.$emit('abrirVisualizacao', idRecurso)
    },
    responderRecursoContrarrazao(idRecurso){
      this.$emit('criarResposta', idRecurso)
    },
    criarContrarrazao(idRecurso){
      this.$emit('criarContrarrazao', idRecurso)
    },
    extrairLotes(lotes){
      const lotesDescricao = lotes.map(item => item.descricao)
      return lotesDescricao.join(', ')
    },
    exibirCriarContrarrazao(recurso){
      if(this.ehContrarrazao){
        return false;
      }
      const usuarioAtualId = this.$store.state.loki.user.domainId
      const usuarioEhDiferente = recurso.fornecedor.id !== usuarioAtualId
      const naoCriouContrarrazao = !this.contrarrazoes.some(contrarrazao => {
        return contrarrazao.fornecedor.id === usuarioAtualId && contrarrazao.recursoId === recurso.id
      })
      return usuarioEhDiferente && naoCriouContrarrazao && this.ehFornecedorParticipante
    },
    prazoEncerrado(recurso){
      return recurso.lotes.every(lote => lote.prazoEncerradoParaRecurso)
    }
  }
}
</script>
<style scoped lang="stylus">
.tabela-vazia
  display flex
  align-items center
  justify-content center
  border: 2px solid #ccc
  background-color: #eeeeee
  color: #7b7b7b
  height 50px

.no-hover
  pointer-events: none

</style>